<script setup lang="ts">
const { data: campaign, error } = await useFetch('/api/giveaway/active')

const show = ref(false)
let timer: ReturnType<typeof setTimeout> | null = null

onMounted(() => {
  if (error.value || !campaign.value) return
  if (sessionStorage.getItem('giveaway_popup_dismissed')) return
  timer = setTimeout(() => { show.value = true }, 3000)
})

onUnmounted(() => {
  if (timer) clearTimeout(timer)
})

function close() {
  show.value = false
  sessionStorage.setItem('giveaway_popup_dismissed', '1')
}
</script>

<template>
  <Transition name="fade">
    <div
      v-if="show && campaign"
      class="fixed inset-0 z-[200] flex items-center justify-center"
    >
      <div
        class="absolute inset-0 bg-dark/50"
        @click="close"
      />
      <div class="relative bg-surface rounded-xl max-w-sm w-full mx-4 overflow-hidden shadow-xl">
        <button
          class="absolute top-3 right-3 z-10 flex items-center justify-center size-8 rounded-full text-secondary hover:text-dark hover:bg-raised transition-colors"
          aria-label="Close"
          @click="close"
        >
          <svg class="size-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </button>

        <img
          v-if="campaign.hero_image_url"
          :src="campaign.hero_image_url"
          :alt="campaign.title"
          class="w-full h-48 object-cover"
        >

        <div class="py-6 px-8 text-center flex flex-col items-center gap-4">

          <h2 class="font-serif text-2xl text-brand leading-8">
            {{ campaign.title }}
          </h2>

          <div
            v-if="campaign.promo_copy"
            class="font-serif text-md text-secondary leading-6 [&_p]:m-0"
            v-html="campaign.promo_copy"
          />

          <NuxtLink
            :to="`/giveaway/${campaign.slug}`"
            class="w-full"
            @click="close"
          >
            <AppButton
              type="Primary"
              size="Large"
              :label="campaign.cta_label || 'Enter Giveaway'"
              class="w-full"
            />
          </NuxtLink>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
